import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";



interface NocSapLogState {
  data: any | null;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | null;
}
const initialState: NocSapLogState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getNocSapLogData: any = createAsyncThunk(
  "noc/sap-logs",
  async (requestBody: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.NOC_SAP_LOGS,
        requestBody
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);



const nocSapLogSlice = createSlice({
  name: "reset",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNocSapLogData.pending, (state) => {
        state.loading = "pending";
        state.error = null;
        state.action = "list";
      })
      .addCase(getNocSapLogData.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getNocSapLogData.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload;
      });
  },
});

export const { resetAll } = nocSapLogSlice.actions;
export default nocSapLogSlice.reducer;
